import React from "react";
import "./Topics.css";

export default function Topics() {
  const topics = [
    "Computer Networks",
    "5G MIMO, Massive MIMO",
    "Network Security",
    "Optical Communication/Underwater Optical Communication",
    "Wireless Communication",
    "Cryptography",
    "Cloud Computing",
    "Mobile Adhoc Networks",
    "Vehicular Adhoc Networks",
    "Cyber Security",
    "Communication Systems",
    "Communication Engineering",
    "Computer Engineering",
    "Computer Science and Engineering",
  ];

  return (
    <section className="ijacna-topics-section">
      <div className="ijacna-topics-container">
        <h2 className="ijacna-topics-title">TOPICS</h2>

        <p className="ijacna-topics-subtitle">
          SUBJECT COVERED BY THIS JOURNAL (BUT NOT LIMITED TO) ARE:
        </p>

        <ul className="ijacna-topics-list">
          {topics.map((topic, index) => (
            <li key={index} className="ijacna-topic-item">
              <span className="ijacna-topic-arrow">»</span> {topic}
            </li>
          ))}
        </ul>

        <div className="ijacna-topics-categories">
          <p className="ijacna-category-heading">
            The IJACNA Journal invites research contributions in the following
            categories:
          </p>
          <ol className="ijacna-category-list">
            <li>Original research.</li>
            <li>
              Survey/Review articles, providing a comprehensive review on a
              scientific topic.
            </li>
            <li>
              Fast Communications: Short, self-contained articles on ongoing
              research.
            </li>
            <li>Technical Notes.</li>
          </ol>
        </div>
      </div>
    </section>
  );
}
